import React from "react";

import { API_URL } from "../../constant";
import { App } from "../../firebase";

import { useHistory } from "react-router-dom";
import BigTitle from "../BigTitle";
function AddCard() {
  const [loading, setLading] = React.useState(false);
  const db = App.firestore();
  const history = useHistory();

  const [size, setSize] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  React.useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const getUserInfos = (uid, com) => {
    var docRef = db.collection("users").doc(uid);

    docRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          console.log("Document data:", doc.data());
          const { customerStripeId } = doc.data();
          com(customerStripeId);
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
      .catch((error) => {
        console.log("Error getting document:", error);
      });
  };

  // STEP 2: make the payment after filling the form properly
  const makePayment = async (e) => {
    e.preventDefault();
    setLading(true);
    getUserInfos(App.auth().currentUser.uid, (customerId) => {
      fetch(API_URL + "payment-method-card", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          number: e.target.cardnumber.value + "",
          exp_month: e.target.expmonth.value,
          exp_year: e.target.expyear.value,
          cvc: e.target.cvv.value,
          customerId: customerId,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          setLading(false);
          if (data.id) {
            alert("Carte ajoutée");
            history.push("/mon-compte#add-card-successful");
          } else {
            console.log(data);
            alert("Une erreur s'est produite");
          }
        })
        .catch((err) => {
          console.log(err);
          setLading(false);
          alert("Carte invalide");
        });
    });
  };

  return (
    <>
      <BigTitle title="Ajout d'une carte" />
      <div class="row" style={{ maxWidth: 784, margin: "60px auto" }}>
        <div class="col-75">
          <div class="container">
            <div class="vous-avez-dj-un-compte raleway-bold-eerie-black-20px">
              Formulaire sécurisée
            </div>
            <div className="content-bloc" style={{ width: "100%" }}>
              <div className="content-sha">
                <form onSubmit={makePayment}>
                  <div
                    class="row"
                    style={{ flexDirection: size.width <= 428 && "column" }}
                  >
                    <div class="col-50">
                      <input
                        class="roboto-normal-16px"
                        style={{ padding: "10px", border: "none" }}
                        type="number"
                        id="ccnum"
                        name="cardnumber"
                        placeholder="N° de carte"
                        required
                        autoFocus={true}
                      />

                      <div
                        style={{
                          marginBottom: 9,
                          backgroundColor: "#BFBFBF",
                          width: "100%",
                          height: 1,
                        }}
                      />
                    </div>

                    <div class="col-50">
                      <input
                        className="roboto-normal-16px"
                        style={{
                          padding: "10px",
                          border: "none",
                          width: "100%",
                        }}
                        type="number"
                        id="expmonth"
                        name="expmonth"
                        min={1}
                        max={12}
                        placeholder="Mois d'éxpiration (1 - 12)"
                        required
                      />
                      <div
                        style={{
                          marginBottom: 9,
                          backgroundColor: "#BFBFBF",
                          width: "100%",
                          height: 1,
                        }}
                      />
                    </div>
                  </div>

                  <div
                    class="row"
                    style={{ flexDirection: size.width <= 428 && "column" }}
                  >
                    <div class="col-50">
                      {/* <label for="expyear">Année d'éxpiration</label> */}
                      <input
                        className="roboto-normal-16px"
                        style={{ padding: "10px", border: "none" }}
                        type="number"
                        id="expyear"
                        name="expyear"
                        min={2022}
                        placeholder="Année d'éxpiration (2024)"
                        required
                      />
                      <div
                        style={{
                          marginBottom: 9,
                          backgroundColor: "#BFBFBF",
                          width: "100%",
                          height: 1,
                        }}
                      />
                    </div>
                    <div class="col-50">
                      <input
                        className="roboto-normal-16px"
                        style={{ padding: "10px", border: "none" }}
                        type="text"
                        id="cvv"
                        name="cvv"
                        placeholder="CVV"
                        required
                      />
                      <div
                        style={{
                          marginBottom: 9,
                          backgroundColor: "#BFBFBF",
                          width: "100%",
                          height: 1,
                        }}
                      />
                    </div>
                  </div>
                  {loading ? (
                    <div
                      style={{ margin: "auto", padding: "60px 0px", width: 55 }}
                    >
                      <div class="loader" />
                    </div>
                  ) : (
                    <input
                      type="submit"
                      class="bouton-plein border-1px-dove-gray sinscrire raleway-bold-eerie-black-14px btn"
                      style={{
                        height: 55,
                        marginTop: "20px",
                        color: "white",
                      }}
                      value="Ajouter"
                    />
                  )}
                </form>
              </div>
            </div>
            <p className="raleway-normal-silver-13px ">
              Vos données personnelles seront utilisées pour le traitement de
              votre carte, vous accompagner au cours de votre visite du site
              web, et pour d’autres raisons décrites dans notre{" "}
              <a href="/privacy">politique de confidentialité.</a>
              <br />
              <br />
              Notre partenaire Stripe réalise le traitement et l'enregistrement
              des données bancaires onFleek.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddCard;
